import {
  IStoreDepositOptionAllowedStores,
  IStoreDepositOptionResponse,
  IUpdateStoreDepositOptionBody,
} from "src/@types/store-deposit-option";

import { Tags } from "../enum/tags";
import { toQueryParams } from "@/utils/to-query-params";
import { apiSlice } from "./http";

const STORE_DEPOSIT_OPTION_URL = "/store-deposit-option";
const STORE_DEPOSIT_OPTION_ALLOWED_STORES_URL = `${STORE_DEPOSIT_OPTION_URL}/allowed-stores`;

interface ListDepositOptionsRequest {
  url: string;
  method: "GET";
}

export function buildListDepositOptionsRequest(
  storeCode: number,
): ListDepositOptionsRequest {
  return {
    url: `${STORE_DEPOSIT_OPTION_URL}?${toQueryParams({ storeCode })}`,
    method: "GET",
  };
}

interface AllowedStoresRequest {
  url: string;
  method: "GET";
}

export function buildAllowedStoresRequest(): AllowedStoresRequest {
  return { url: STORE_DEPOSIT_OPTION_ALLOWED_STORES_URL, method: "GET" };
}

interface UpdateDepositOptionsRequest {
  url: string;
  method: "PUT";
  body: IUpdateStoreDepositOptionBody;
}

export function buildUpdateDepositOptionsRequest(
  body: IUpdateStoreDepositOptionBody,
): UpdateDepositOptionsRequest {
  return { url: STORE_DEPOSIT_OPTION_URL, method: "PUT", body };
}

export const storeDepositOptionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoreDepositOptions: builder.query<IStoreDepositOptionResponse, number>({
      query: buildListDepositOptionsRequest,
      providesTags: [Tags.STORE_DEPOSIT_OPTION],
    }),
    getStoreDepositOptionAllowedStores: builder.query<
      IStoreDepositOptionAllowedStores,
      void
    >({
      query: buildAllowedStoresRequest,
    }),
    updateStoreDepositOptions: builder.mutation<
      void,
      IUpdateStoreDepositOptionBody
    >({
      query: buildUpdateDepositOptionsRequest,
      invalidatesTags: [Tags.STORE_DEPOSIT_OPTION],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetStoreDepositOptionsQuery,
  useGetStoreDepositOptionAllowedStoresQuery,
  useUpdateStoreDepositOptionsMutation,
} = storeDepositOptionApi;
